module.exports = __webpack_public_path__ + "img/Banner_Home_1.570e90c8.png";